import { tv } from 'tailwind-variants'

const inputStyles = tv({
  base: 'w-full rounded-md border-2 px-3 font-semibold shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-teal-600',
  variants: {
    size: {
      sm: 'text-md py-1',
      md: 'py-3 text-lg'
    }
  }
})

const selectStyles = tv({
  base: 'block w-full rounded-md border-2 border-teal-100 bg-white px-3 py-4 text-lg font-bold shadow-sm focus:border-teal-600 focus:outline-none focus:ring-teal-600',
  variants: {
    size: {
      sm: 'text-md py-1',
      md: 'py-3 text-lg'
    },
    hidden: {
      true: 'hidden'
    }
  }
})

const selectLabelStyles = tv({
  base: '',
  variants: {
    size: {
      sm: 'text-md mb-2 font-bold',
      md: 'mb-3 font-semibold'
    },
    center: {
      true: 'text-center text-lg text-teal-600',
      false: 'text-md text-left text-teal-800'
    }
  }
})

export { inputStyles, selectStyles, selectLabelStyles }
